import {
  ApplicationConfig,
  importProvidersFrom,
  isDevMode,
  LOCALE_ID,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter, TitleStrategy } from '@angular/router';

import { registerLocaleData } from '@angular/common';
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
  withInterceptorsFromDi,
} from '@angular/common/http';
import localePt from '@angular/common/locales/pt';
import {
  provideClientHydration,
  withEventReplay,
} from '@angular/platform-browser';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { provideNgxSkeletonLoader } from 'ngx-skeleton-loader';
import { routes } from './app.routes';
import { authProviders } from './auth/auth-helper';
import { authLogoutInterceptor } from './auth/auth-logout.interceptor';
import { PrefixedTitleStrategy } from './core/strategies/prefixed-title.strategy';

registerLocaleData(localePt);

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideClientHydration(withEventReplay()),
    { provide: TitleStrategy, useClass: PrefixedTitleStrategy },
    provideHttpClient(
      withFetch(),
      withInterceptorsFromDi(),
      withInterceptors([authLogoutInterceptor])
    ),
    { provide: LOCALE_ID, useValue: 'pt-br' },
    provideNgxSkeletonLoader(),
    authProviders(),
    importProvidersFrom(StoreModule.forRoot({}), EffectsModule.forRoot()),
    provideStoreDevtools({ maxAge: 25, logOnly: !isDevMode() }),
  ],
};
